module.exports = __webpack_public_path__ + "media/images/arrow-right-black-481b0a756d90b45f3895546142232ed5.svg";